// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"4d3b2235","81":"daae259c","273":"7a986cb4","335":"61726e77","361":"767b7507","527":"1ab710b8","673":"d8de212a","695":"c4c78867","787":"ab75545b","815":"b6222a40","860":"6ac85f8f","889":"9322f099","911":"2bb1dccf"}[chunkId] + ".chunk.js";
};